import project from '@/api/report/project'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  // generate daily item used pdf
  dailyItemUsed(context, attributes = {}) {
    return project.dailyItemUsed({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  dailyItemUsedExcel(context, data) {
    return project.dailyItemUsedExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  dailyTaskUpdate(context, attributes = {}) {
    return project.dailyTaskUpdate({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  dailyTaskUpdateExcel(context, data) {
    return project.dailyTaskUpdateExcel(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        data
      )
    )
  },
  detailProjectExcel(context, data) {
    return project.detailProjectExcel(data)
  },
  performancesExcel(context, data) {
    return project.performancesExcel(data)
  },
  performances(context, data) {
    return project.performances(data)
  },
  getProject(context, payload) {
    return project.project(payload)
  },
  getCreator(context, payload) {
    return project.creator(payload)
  },
  getSite(context, payload) {
    return project.site(payload)
  },
  getProduct(context, payload) {
    return project.product(payload)
  },
  getCategory(context, payload) {
    return project.category(payload)
  },
  getOwner(context, payload) {
    return project.owner(payload)
  },
  getStatus(context, payload) {
    return project.status(payload)
  },
  getCustomer(context, payload) {
    return project.customer(payload)
  },
  getTask(context, payload) {
    return project.task(payload)
  },
  getOwnerByProject(context, params = {}) {
    return project.ownerByProjects(params)
  },
  getMilestone(context, params = {}) {
    return project.milestone({ params })
  },
  getBorrowing(context, params = {}) {
    return project.borrowing(params)
  },
  getRequesters(context, params = {}) {
    return project.requesters(params)
  },
  detailProject(context, payload) {
    return project.detailProject(payload)
  },
  siteCheckInOut(context, payload) {
    return project.siteCheckInOut(payload)
  },
  siteCheckInOutExcel(context, payload) {
    return project.siteCheckInOutExcel(payload)
  },
  borrowingByProject(context, payload) {
    return project.borrowingByProject(payload)
  },
  borrowingByProjectExcel(context, payload) {
    return project.borrowingByProjectExcel(payload)
  },
  summaryMaterial(context, payload) {
    return project.summaryMaterial(payload)
  },
  summaryMaterialExcel(context, payload) {
    return project.summaryMaterialExcel(payload)
  },
  projectList(context, payload) {
    return project.projectList(payload)
  },
  projectListExcel(context, payload) {
    return project.projectListExcel(payload)
  },
  projectListPdf(context, payload) {
    return project.projectListPdf(payload)
  },
  materialClearanceByProject(context, payload) {
    return project.materialClearanceByProject(payload)
  },
  materialClearanceByProjectExcel(context, payload) {
    return project.materialClearanceByProjectExcel(payload)
  },
  materialClearanceByProjectPdf(context, payload) {
    return project.materialClearanceByProjectPdf(payload)
  },
  formViewModel(context, attributes = {}) {
    return project.formViewModel({ params: attributes })
  },
  update(context, { id, data }) {
    return project.update(id, data)
  },
}
